import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { CreditCard, Trash2, Star } from "lucide-react";

/**
 * Display card for a saved payment method.
 */
export default function PaymentMethodCard({
  method,
  onDelete,
  onSetDefault,
}) {
  const getBrandIcon = (brand) => {
    // Could swap for actual brand SVGs later
    return <CreditCard className="w-8 h-8 text-primary" />;
  };

  return (
    <Card className="border-borderDefault">
      <CardContent className="p-5">
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center gap-3">
            {getBrandIcon(method.brand)}
            <div>
              <p className="text-sm font-medium text-textPrimary">
                {method.label || `${method.brand || method.method_type} ****${method.last4}`}
              </p>
              <p className="text-xs text-textSecondary capitalize">
                {method.gateway}
              </p>
            </div>
          </div>
          {method.is_default && (
            <Badge variant="info" className="flex items-center gap-1">
              <Star className="w-3 h-3" /> Default
            </Badge>
          )}
        </div>

        {method.expiry_month && method.expiry_year && (
          <p className="text-sm text-textSecondary mb-3">
            Expires {String(method.expiry_month).padStart(2, "0")}/
            {method.expiry_year}
          </p>
        )}

        <div className="flex gap-2">
          {!method.is_default && (
            <Button
              variant="outline"
              size="sm"
              className="flex-1"
              onClick={() => onSetDefault(method.id)}
            >
              Set Default
            </Button>
          )}
          <Button
            variant="ghost"
            size="sm"
            className="text-destructive hover:bg-destructive/10"
            onClick={() => onDelete(method.id)}
          >
            <Trash2 className="w-4 h-4" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
